import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "./ManageAllOrder.css";
const ManageAllOrder = () => {
  const [orders, setOrders] = useState([]);
  useEffect(() => {
    fetch("https://carame-cake-server-site.vercel.app/orders")
      .then((res) => res.json())
      .then((data) => setOrders(data));
  }, []);
  // handle delete btn
  const handleDeletBtn = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`https://carame-cake-server-site.vercel.app/orders/${id}`)
          .then((res) => {
            const remaining = orders.filter((order) => order._id !== id);
            setOrders(remaining);
          });
        Swal.fire("Deleted!", "Your file has been deleted.", "success");
      }
    });
  };
  const updateStatus = (id) => {
    axios
      .put(`https://carame-cake-server-site.vercel.app/orders/${id}`)
      .then(() => {})
      .catch((error) => {
        console.log(error);
      });
    const findItem = orders.find((book) => book._id === id);
    if (findItem) {
      findItem.status = "Shipped";
      const reamingData = orders.filter((book) => book._id !== id);
      setOrders([findItem, ...reamingData]);
    }
  };
  return (
    <div className="dash_bg">
      <table className="container table table-responsive alt-2 dash_bg">
        <thead>
          <tr>
            <th>Products</th>
            <th>User Name</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order) => (
            <tr key={order._id}>
              <td>
                {" "}
                <img
                  src={order.img}
                  data-at2x="pic/190x130@2x.jpg"
                  alt=""
                  width="190"
                  height="130"
                />
                <h6>{order.title}</h6>
                {/* <p className="mb-0">{order.Description.slice(0, 30)}</p> */}
              </td>
              <td>
                <p>{order.name}</p>
              </td>
              <td className="room-price text-center">
                <h2 className="btn btn-outline-light">{order.status}</h2>
              </td>
              <td>
                <button
                  onClick={() => handleDeletBtn(order._id)}
                  className="btn"
                >
                  <i className="fas fa-trash text-light"></i>
                </button>
                {/* update button */}
                <button onClick={() => updateStatus(order._id)} className="btn">
                  <img
                    style={{ height: "25px" }}
                    src="https://i.ibb.co/7YhPJPw/updated.png"
                    alt=""
                  />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ManageAllOrder;
